import React, { Component } from 'react';
import { connect } from 'react-redux';
import {MicroPipette} from '@learningblocks/storybook-components/lib/PhotosynthesisComponents/MicroPipette';
import { withTranslation } from 'react-i18next'

import {
  setVol,
  setVolume,
  toggleShowVolumeModal,
  removeTip,
  onFirstStopper,
  togglePlungerTooltip,
  onSecondStopper,
  onMix,
} from 'actions';


class Graphics extends Component {

  constructor(props) {
    super(props);

  }

  render(){
    return(
    <MicroPipette
      type={this.props.type}
      hasTip={this.props.hasTip}
      solution={(this.props.solution)?'red':null}
      volume={this.props.volume}
      showVolumeModal={this.props.showVolumeModal}
      contactElement={this.props.contactElement}
      plungerTooltip={this.props.plungerTooltip}
      lang={this.props.lang}
      notebookExpanded={this.props.notebookExpanded}
      setVolume={
        (data) =>{
          this.props.setVol({ volume: data.volume, id: this.props.id })
        }
      }
      toggleShowVolumeModal={
        (data) =>{
          this.props.toggleShowVolumeModal({ data, id: this.props.id })
        }
      }
      removeTip={
        (data) =>{
          this.props.removeTip({ data, id: this.props.id })
        }
      }
      togglePlungerTooltip={
        (data) =>{
          this.props.togglePlungerTooltip({ data, id: this.props.id })
        }
      }
      onFirstStopper={
        (data) =>{
          this.props.onFirstStopper({ data, id: this.props.id })
        }
      }
      onSecondStopper={
        (data) =>{
          this.props.onSecondStopper({ data, id: this.props.id })
        }
      }
      onMix={
        (data) =>{
          this.props.onMix({ data, id: this.props.id })
        }
      }
    />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    id: ownProps.id,

    hasTip: state.pipette.pipettes[ownProps.id-1].tipAttached,
    solution: state.pipette.pipettes[ownProps.id-1].solution,
    volume: state.pipette.pipettes[ownProps.id-1].volume,
    showVolumeModal: state.pipette.pipettes[ownProps.id-1].showVolumeModal,
    type: state.pipette.pipettes[ownProps.id-1].type,
    contactElement: state.pipette.pipettes[ownProps.id-1].contactElement,
    plungerTooltip: state.pipette.pipettes[ownProps.id-1].togglePlungerTooltip,
    lang: state.scene.lang,
    notebookExpanded: state.scene.notebookExpanded
  }
}

export default connect(mapStateToProps, {
  setVol,
  setVolume,
  toggleShowVolumeModal,
  removeTip,
  onFirstStopper,
  togglePlungerTooltip,
  onSecondStopper,
  onMix,
})(withTranslation()(Graphics));
